<template>
    <div class="browse-list">
        <v-btn fixed bottom left disabled fab v-if="loading">
            <v-progress-circular indeterminate color="accent" />
        </v-btn>
        <div ref="list">
            <slot v-bind:items="renderedItems" />
        </div>
    </div>
</template>

<script>
import throttle from 'throttleit'

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        scrollTriggerPercentage: {
            type: Number,
            required: false,
            default: 15,
        },
    },
    data () {
        return {
            renderedItems: [],
        }
    },
    watch: {
        items (items) {
            this.updateRenderedItems(items)
        },
    },
    computed: {
        hasItems () {
            return this.items.length > 0
        },
        throtthledScrollListener () {
            return throttle(this.scrollListener, 50)
        },
    },
    methods: {
        async updateRenderedItems (items) {
            const firstItem = this.getFirstItemInView()

            this.renderedItems = items
            await this.$nextTick()

            if (firstItem) {
                this.scrollToItem(firstItem)
            }
        },
        getFirstItemInView () {
            if (!this.$refs.list) {
                // eslint-disable-next-line no-console
                console.warn('No reference to items container')
                return
            }

            const elements = [...this.$refs.list.querySelectorAll(`[data-list-item]`)]
            let rect = null
            const firstElement = elements.find((el) => {
                rect = el.getBoundingClientRect()
                return rect.top >= 0
            })

            if (!firstElement || !rect) {
                return null
            }

            const id = firstElement.dataset.listItem
            if (id) {
                this.$emit('current', id)
            }

            return {
                el: firstElement,
                top: rect.top,
                id,
            }
        },
        scrollToItem (item) {
            const newTop = item.el.getBoundingClientRect().top
            window.scrollBy(0, newTop - item.top)
        },
        scrollListener () {
            if (this.loading) {
                return
            }

            this.getFirstItemInView()

            const margin = document.body.scrollHeight * (this.scrollTriggerPercentage / 100)
            const isTop = window.scrollY <= margin
            if (isTop) {
                this.$emit('up')
                return
            }

            const isBottom = (document.body.scrollHeight - window.scrollY - window.innerHeight) <= margin
            if (isBottom) {
                this.$emit('down')
            }
        },
    },
    async mounted () {
        this.updateRenderedItems(this.items)
        document.addEventListener('scroll', this.throtthledScrollListener)
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.throtthledScrollListener)
    },
}
</script>
